import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Link, useHistory } from "react-router-dom";
import { MDBBtn } from "mdb-react-ui-kit";
import logo from "../images/home-body/logo gishniz.png";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Box from "@mui/material/Box";
// import "./Header.css";
import imageLoginwhite from "../images/login img/user.svg";
import imageLogout from "../images/login img/log-out gray.svg";
import nextLogin from "../images/login img/play (1).svg";
// config
import configData from "../config/config.json";
//icon
import DashboardCustomizeRoundedIcon from "@mui/icons-material/DashboardCustomizeRounded";

const RegisterBusiness = (props) => {
  const location = useLocation().pathname;
  const history = useHistory();

  const [showmenu, setshowmenu] = useState(false);
  const [showmenuMob, setshowmenuMob] = useState(false);

  // login part
  const handleShow = () => {
    setshowmenu((prev) => !prev);
  };

  const handleShowAway = () => {
    setshowmenu(false);
  };
  const handleShowMob = () => {
    setshowmenuMob((prev) => !prev);
  };

  const handleShowAwayMob = () => {
    setshowmenuMob(false);
  };
  const deleteAllCookies = () => {
    eraseCookie("OwnerId");
    eraseCookie("BizId");
    eraseCookie("BizUuid");
    eraseCookie("token");
    setshowmenu(false);
    setshowmenuMob(false);

    history.push({
      pathname: "/",
    });
  };

  const lanHandler = (event) => {
    // if (getCookie("_gapp_Locale") == "") {
    window.location.href = `https://en-biz.gishniz.com${window.location.pathname}`;
    // window.location.href = `https://en-biz.gishniz.app${window.location.pathname}`;
    // }
  };

  const backToDashboardHandler = () => {
    if (
      getCookie("BizId") !== JSON.parse(localStorage.getItem("OwnerDetail")).bId
    ) {
      setCookie(
        "BizId",
        JSON.parse(localStorage.getItem("OwnerDetail")).bId,
        1
      );
      history.push({
        pathname: "/business-dashboard",
      });
    }
  };

  //  setCookie
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    document.cookie =
      cname +
      "=" +
      cvalue +
      ";" +
      expires +
      // " domain=en-biz.gishniz.app; path=/";
      " domain=en-biz.gishniz.com; path=/";
  }
  //  getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  //  delete coockie
  function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
    document.cookie =
      name +
      "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=en-biz.gishniz.com; path=/";
  }

  return (
    <>
      <div className="register-business-header ">
        <div className="d-flex align-items-baseline">
          <Link to="/" className=" logo-header2-a ">
            <img src={logo} alt="logo gishniz" className="logo-header2-lap" />
          </Link>
          <p className="register-business-title d-none d-md-block">
            برای کسب‌وکار
          </p>
        </div>
        <p className="register-business-title d-md-none">برای کسب‌وکار</p>

        <div className="d-flex align-items-center">
          <MDBBtn className="chamge-lan-btn" onClick={lanHandler}>
            En
          </MDBBtn>

          {/* laptop size */}
          <div className="d-md-flex d-none">
            <ClickAwayListener onClickAway={handleShowAway}>
              <Box className="position-relative">
                {getCookie("OwnerId") &&
                  JSON.parse(localStorage.getItem("OwnerDetail")) && (
                    <>
                      <div
                        className={
                          showmenu
                            ? "select_login_sucess select_login_sucess_color "
                            : "select_login_sucess select_login_sucess2"
                        }
                        onClick={handleShow}
                      >
                        <div>
                          <object
                            onClick={handleShow}
                            className="imageLogin_success_header"
                            data={imageLoginwhite}
                            alt=""
                            type="image/svg+xml"
                          ></object>
                        </div>

                        <object
                          onClick={handleShow}
                          className={
                            showmenu
                              ? "nextLogin nextLogin-rotate"
                              : "nextLogin nextLogin-rotateback"
                          }
                          data={nextLogin}
                          alt=""
                          type="image/svg+xml"
                        ></object>
                      </div>
                      {showmenu && (
                        <List
                          onMouseOver={() => setshowmenu(true)}
                          onMouseOut={() => setshowmenu(false)}
                          className="box_show_info_userlogin"
                          component="nav"
                          aria-label="mailbox folders"
                        >
                          <ListItem button>
                            <img
                              className="img20x20 filter-gray"
                              src={"https://cdn.gishniz.com/images/avatar.png"}
                              // src={userIcon}
                              alt="icon"
                            />
                            {
                              JSON.parse(localStorage.getItem("OwnerDetail"))
                                .firstname
                            }
                            {""}{" "}
                            {
                              JSON.parse(localStorage.getItem("OwnerDetail"))
                                .lastname
                            }
                          </ListItem>
                          <Divider />

                          {getCookie("OwnerBizNumber") != 0 && (
                            <>
                              <ListItem onClick={backToDashboardHandler} button>
                                <DashboardCustomizeRoundedIcon className="back-to-dashboard-img filter-gray" />
                                پنل کسب‌وکار
                              </ListItem>
                              <Divider />
                            </>
                          )}

                          <ListItem onClick={deleteAllCookies} button>
                            <img
                              className="img20x20"
                              src={imageLogout}
                              alt="logout icon"
                            />
                            خروج
                          </ListItem>
                        </List>
                      )}
                    </>
                  )}
              </Box>
            </ClickAwayListener>
          </div>
          {/* responsive size */}
          <div className="d-md-none">
            <ClickAwayListener onClickAway={handleShowAwayMob}>
              <Box>
                {getCookie("OwnerId") &&
                  JSON.parse(localStorage.getItem("OwnerDetail")) && (
                    <>
                      <div
                        className={showmenuMob ? "green_login" : " green_login"}
                        onClick={handleShowMob}
                      >
                        <object
                          className="imageLogin_success_header_mobile"
                          data={imageLoginwhite}
                          alt=""
                          type="image/svg+xml"
                          onClick={handleShowMob}
                        ></object>
                        <object
                          className={
                            showmenuMob
                              ? "nextLogin_mobile nextLogin-rotate"
                              : "nextLogin_mobile nextLogin-rotateback"
                          }
                          data={nextLogin}
                          alt=""
                          type="image/svg+xml"
                          onClick={handleShowMob}
                        ></object>
                      </div>
                      {showmenuMob && (
                        <List
                          onMouseOver={() => setshowmenuMob(true)}
                          onMouseOut={() => setshowmenuMob(false)}
                          className="box_show_info_userlogin fix_header_mobile_login"
                          component="nav"
                          aria-label="mailbox folders"
                        >
                          <ListItem button>
                            <img
                              className="img20x20 filter-gray"
                              src={"https://cdn.gishniz.com/images/avatar.png"}
                              // src={userIcon}
                              alt="icon"
                            />
                            {
                              JSON.parse(localStorage.getItem("OwnerDetail"))
                                .firstname
                            }
                            {""}{" "}
                            {
                              JSON.parse(localStorage.getItem("OwnerDetail"))
                                .lastname
                            }
                          </ListItem>
                          <Divider />

                          {getCookie("OwnerBizNumber") != 0 && (
                            <>
                              <ListItem onClick={backToDashboardHandler} button>
                                <DashboardCustomizeRoundedIcon className="back-to-dashboard-img filter-gray" />
                                پنل کسب‌وکار
                              </ListItem>
                              <Divider />
                            </>
                          )}

                          <ListItem onClick={deleteAllCookies} button>
                            <img
                              className="img20x20"
                              src={imageLogout}
                              alt=""
                            />
                            خروج
                          </ListItem>
                        </List>
                      )}
                    </>
                  )}
              </Box>
            </ClickAwayListener>
          </div>
        </div>
      </div>

      {location == "/register-business-step1" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {location == "/register-business-step2" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {location == "/register-business-step3" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {location == "/register-business-step4" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {location == "/register-business-step5" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {location == "/register-business-step6" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="not-active"></li>
                <li className="not-active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {location == "/register-business-step7" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="not-active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {location == "/register-business-step8" ? (
        <div className="row mx-0">
          <div className="col-12 col-md-8 register-business-padd">
            <div className="register-progress ">
              <ul>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
                <li className="active"></li>
              </ul>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default RegisterBusiness;
